// @flow
import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import './styles.css'

import appStoreApple from '../Assets/appstore_apple.png'
import appStoreGoogle from '../Assets/appstore_google.png'

export default class SendMoneyNoWink extends Component {
    render() {
        return (
            <Grid fluid>
                <Row center="sm">
                    <Col xs={12} sm={12} md={12} lg={8}>
                        <div className="mainContainer">
                            <Row center="xs">
                                <Col >
                                    <div className="winkTopLogo"></div>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} sm={12} md={12} lg={8}>
                                    <h1>Acreditar ₡150.000 en mi cuenta</h1>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} sm={12} md={12} lg={8}>
                                    <Row center="xs">
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <div className="creditMessage">El envío de dinero de Iván Alarcón
                                                se acreditará a la cuenta bancario que nos indiqués</div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row center="xs" className="creditAccountInfoRow">
                                <Col xs={12} sm={12} md={12} lg={8}>
                                    <Row start="xs">
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <label className='accountInfoLabel'>Número De Cédula</label>
                                            <input type="text" />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row center="xs" className="creditAccountInfoRow">
                                <Col xs={12} sm={12} md={12} lg={8}>
                                    <Row start="xs">
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                            <label className='accountInfoLabel'>Cuenta Cliente</label>
                                            <input type="text" />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col >
                                    <button className='btn-primary-outline' type='submit'>ACREDITAR DINERO A MI CUENTA</button>
                                </Col>
                            </Row>
                            <Row center="xs" className="creditAccountInfoRow">
                                <Col >
                                    <h1>Descubrí la banca del futuro</h1>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} sm={12} md={12} lg={4}>
                                    <a href='#'>
                                        <img src={appStoreApple} />
                                    </a>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={4}>
                                    <a href='#'>
                                        <img src={appStoreGoogle} />
                                    </a>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} md={12}>
                                    <div className='warningMessage'>El dinero estará disponible por 48 a partir del momento en que recibís este correo. <br />
                                        Después de este periodo, la transferencia no se podrá concretar.</div>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/CreditAccountNoWink/index.js